import axios from "axios";
import {URL_PREFIX} from "../config";

export const getArtistDashboard = (id, cancelToken=null) => {
  return axios.get(URL_PREFIX + '/artist-dashboards/' + id + '/', {
      cancelToken: cancelToken?.token
  })
}
